<template>
  <div v-show="remindDialogVisible" class="mask">
    <div class="content">

        <div class="label flex-start-center">
          <span> 温馨提示 </span>
        </div>
        <p class="remind">购买平台藏品前，需要您通过实名认证</p>
        <div class="btn-div">
          <input type="button" value="取消" class="login-btn cancel"  @click="cancel"/>
          <input type="button" value="去实名认证" class="login-btn" @click="routeLink('/setting','1')"/>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['remindDialogVisible', 'info'],
  data () {
    return {
      remindVisible: false
    }
  },
  watch: {
    'remindDialogVisible': {
      handler (val) {
        if (val) {

        }
      },
      deeply: true
    }
  },
  mounted () {
  },
  methods: {
    cancel () {
      this.$emit('changeRemindDialogVisible', false)
      // this.$emit('remindDialogVisible', false)
      // console.log()
    },
    routeLink (path, query) {
      this.cancel()
      setTimeout(() => {
        this.$router.push({
          path: path,
          query: { tabIndex: 1, redirect: this.$router.currentRoute.fullPath }
        })
      }, 10)
    }
  }
}
</script>

<style lang="scss" scoped>
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .content {
    position: relative;
    z-index: 1;
    height: auto;
    overflow: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 494px;
    height: 272px;
    background: #FFFFFF;
    box-shadow: 0px 11px 30px 0px rgba(0, 0, 0, 0.05);
    border-radius: 14px;
    opacity: 0.95;
    margin:-136px auto 0 auto;
    top:50%;
    @media screen and(max-width:768px) {
        width: 100%;
      }
    .label{
      font-size: 24px;
      font-weight: 500;
      color: #363636;
      line-height: 33px;
      margin-top:33px;
    }
    .remind{
      font-size: 16px;
      font-weight: 400;
      color: #363636;
      line-height: 22px;
      margin-top:42px;
    }
    .btn-div {
      display: flex;
      justify-content: space-around;
      align-content: center;
      width: 80%;
      margin-top:54px;
      .login-btn {
        display: inline-block;
        width: 130px;
        height: 49px;
        background-color: #E8721D;
        border-radius: 5px;
        border: 0;
        font-size: 16px;
        color: #ffffff;
        margin: 0 auto 36px auto;
        cursor: not-allowed;
        &:hover {
          cursor: pointer;
        }
        @media screen and(max-width:768px) {
          width: 130px;
          height: 40px;
        }
      }
      .cancel {
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #E8721D;
        color: #E8721D;
        font-size: 18px;
        margin-right: 9px;
        cursor: pointer;
        @media screen and(max-width:768px) {
          width: 130px;
          height: 40px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/conponents/realnameRemind/index.vue